import ConditionReportConfig from "./ConditionReportConfig";

export default ConditionReportConfig;